import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private _dark = false;

  constructor() {
    this._dark = localStorage.getItem('admin-theme') === 'dark';
    this.apply();
  }

  get isDark(): boolean {
    return this._dark;
  }

  toggle(): void {
    this._dark = !this._dark;
    localStorage.setItem('admin-theme', this._dark ? 'dark' : 'light');
    this.apply();
  }

  private apply(): void {
    document.documentElement.setAttribute('data-theme', this._dark ? 'dark' : 'light');
  }
}
